module.exports = __webpack_public_path__ + "img/gonggongkecheng.f8879657.png";